import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const StockProcessClone = () => {
  const [isProcessPrevDis, setIsProcessPrevDis] = useState(true);
  const [isProcessNextDis, setIsProcessNextDis] = useState(false);

  const handleProcessChange = (swiper) => {
    setIsProcessPrevDis(swiper.isBeginning);
    setIsProcessNextDis(swiper.isEnd);
  };

  return (
    <div>
      <div className="why-custom-swiper ">
        <Swiper
          spaceBetween={12}
          slidesPerView={3}
          modules={[Navigation, A11y, Pagination]}
          pagination={{
            clickable: true,
            // el: ".forex-paginate",
          }}
          scrollbar={{ draggable: true }}
          navigation={{
            prevEl: ".why-custom-prev-arrow",
            nextEl: ".why-custom-next-arrow",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          }}
          onSlideChange={handleProcessChange}
          onReachBeginning={() => setIsProcessPrevDis(true)}
          onReachEnd={() => setIsProcessNextDis(true)}
          onFromEdge={() => {
            setIsProcessPrevDis(false);
            setIsProcessNextDis(false);
          }}
        >
          <SwiperSlide>
            <div className="st-process-cards">
              <h6>Market Research and Analysis</h6>
              <p>
                Before diving into stock trading app development, conduct
                thorough market research. Understand the target audience,
                identify competitors, and analyze market trends to build a
                competitive product.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-process-cards ">
              <h6> Define Features and Functionality</h6>
              <p>
                List all the features your app will include. Stock trading app
                development should align with user needs, ensuring a robust and
                feature-rich platform.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-process-cards ">
              <h6>Design the User Interface (UI)</h6>
              <p>
                A clean and attractive UI is essential. During the stock trading
                app development phase, focus on creating designs that are both
                visually appealing and functional.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-process-cards ">
              <h6>Backend Development</h6>
              <p>
                The backend is the engine of your app. Stock trading app
                development involves building a secure and scalable backend that
                supports high-speed transactions and data processing.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-process-cards">
              <h6>Frontend Development</h6>
              <p>
                Frontend development ensures users can interact seamlessly with
                the app. Stock trading app development incorporates responsive
                design for smooth user experiences.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-process-cards">
              <h6>Integration of APIs</h6>
              <p>
                Stock trading app development relies on APIs for accessing
                real-time stock market data, payment gateways, and other
                essential services.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="st-process-cards ">
              <h6>Testing and Quality Assurance</h6>
              <p>
                Rigorous testing is crucial to ensure the app functions as
                intended. Stock trading app development includes performance
                testing, security checks, and bug fixing.
              </p>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="st-process-cards ">
              <h6> Launch and Marketing</h6>
              <p>
                Once the stock trading app is ready, launch it. Effective
                marketing strategies are vital to promote your stock trading app
                development project and attract users.
              </p>
            </div>
          </SwiperSlide>
        </Swiper>

        <div className="why-custom-btn-wrapper st-key-btn-wrapper">
          <button
            className={`why-custom-prev-arrow st-key-left-btn ${
              isProcessPrevDis ? "disabled" : ""
            }`}
            style={{
              color: isProcessPrevDis ? "#8C8D8D" : "#fff",
              cursor: isProcessPrevDis ? "not-allowed" : "pointer",
              backgroundColor: isProcessPrevDis ? "#24272899" : "#24272899",
            }}
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <button
            className={`why-custom-next-arrow st-key-right-btn ${
              isProcessNextDis ? "disabled" : ""
            }`}
            style={{
              color: isProcessNextDis ? "#8C8D8D" : "#fff",
              cursor: isProcessNextDis ? "not-allowed" : "pointer",
              backgroundColor: isProcessNextDis ? "#24272899" : "#24272899",
            }}
          >
            <i className="fa-solid fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockProcessClone;
